module.exports = __webpack_public_path__ + "static/media/notFound.b62e70fa.png";